import { registerModal } from 'features/Modal/ModalRegistry'
import { ContactTriggerFlowModal } from './ContactTriggerFlowModal'
import { showModal } from 'features/Modal/Modal.actions'
import { IContactClient } from 'features/Contacts/types'

export const modalType = 'CONTACT_TRIGGER_FLOW_MODAL'
registerModal(modalType, ContactTriggerFlowModal)
export const showContactTriggerFlowModal = (modalProps: { contact: IContactClient }) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/Contacts/ContactTriggerFlowModal/ContactTriggerFlowModal.action.ts